<template>
<div v-if="showPriceModal">
  <div class="guest-price-warning">
    <div class="container">
      <site-text-block class="big-modal" type="guest_catalog_message"/>
      <button class="" @click="showPriceModal = false">{{ $t('guest_mode_warning_3') }}</button>
    </div>
  </div>
</div>
</template>


<script>
import SiteTextBlock from '@/components/blocks/site-text-block';

export default {
  components: {
    SiteTextBlock,
  },
  data() {
    return {
      showPriceModal: false,
    }
  },
  mounted(){
    if (!this.$auth.loggedIn) {
      if(!this.$device.isCrawler)
        this.showPriceModal = true;
    } 
  },
}
</script>
<i18n lang="yaml">
ru:
  guest_mode_warning_3: 'Понятно'
en:
  guest_mode_warning_3: 'OK'
</i18n>
